import qc from 'qc'
import { Event, EventBus } from '@ps/utils/event-bus'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { getIframe } from '@ps/bridge/iframe/iframe'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import { isFreeDrawLineNode } from '@ps/bridge/qc/base'
import { isGroup } from '@ps/bridge/qc/base'
import { getGamePlay } from '@ps/utils/game'

export const DEFAULT_BOX2D_PRECISION = 3
export enum BODYTYPE {
  NOTRIGID = -1, // 非刚体
  STATIC = 0, // 静态刚体
  KINEMATIC = 1, // 运动学刚体
  DYNAMIC = 2, // 动力学刚体
}

type box2dParam = {
  bodyType?: number
  precision?: number
}

export type box2dActionValue = {
  node: qc.Node
  newValue: box2dParam
  oldValue: box2dParam
}

const updateBox2d = (node: qc.Node, param: box2dParam) => {
  const ped = editorScript.getScript(node)
  for (const i in param) {
    ped.$data.box2d[i] = param[i]
  }
}

export const isRigidBody = (node: qc.Node) => {
  const ped = editorScript.getScript(node)
  return ped?.$data.box2d?.bodyType !== BODYTYPE.NOTRIGID
}

export const getRigidBodyType = (node: qc.Node) => {
  const ped = editorScript.getScript(node)
  return ped?.$data.box2d?.bodyType
}

export const psRemoveBox2dBody = (node: qc.Node) => {
  // 删除刚体之前先还原之前的sensor值
  let tnode = node
  if (isGroup(node)) {
    const bindNode = node.getScript('ps.BindNode')
    if (bindNode && bindNode.groupSubRigidNode) {
      tnode = bindNode.groupSubRigidNode
    }
  }
  const ped = tnode.getScript('playsmart.editor.data')
  const body = tnode.getScript('qc.Box2D.Body')
  if (!body || !tnode.b2Body) return
  let sensor = false
  if (ped.$data.box2d.sensor) {
    sensor = ped.$data.box2d.sensor
  }
  body.sensor = sensor
  body.removeBody()
}

export const closePreviewAllBox2dShape = () => {
  const iframeWindow = getIframe()
  if (!iframeWindow.box2d) return
  iframeWindow.box2d.debugDraw = false
  const gamePlay = getGamePlay()
  const nodes = getDescendants(gamePlay)
  for (const i in nodes) {
    const node: qc.Node | undefined = nodes[i]
    if (node && isRigidBody(node) && !isFreeDrawLineNode(node)) {
      psRemoveBox2dBody(node)
    }
  }
}
export const previewSingleBox2dShape = (node: qc.Node) => {
  let tnode = node
  if (isGroup(node)) {
    const bindNode = node.getScript('ps.BindNode')
    if (bindNode && bindNode.groupSubRigidNode) {
      tnode = bindNode.groupSubRigidNode
      tnode.visible = true
    }
  }
  let body = tnode.getScript('qc.Box2D.Body')
  if (!body) {
    body = tnode.addScript('qc.Box2D.Body')
  }
  const type = getRigidBodyType(tnode)
  body.type = type
  const ped = tnode.getScript('playsmart.editor.data')
  let precision = DEFAULT_BOX2D_PRECISION
  if (ped.$data.box2d.precision) {
    precision = ped.$data.box2d.precision
  }
  body.onBodyCreated.addOnce(() => {
    body.sensor = true
    body.isAwake = false
    if (tnode.texture) {
      body.resetShapeFromEdge(precision)
    }
  })
  body.removeBody()
  body.createBody()
}
export const previewSingleBox2dShapeDoubleHack = (node: qc.Node) => {
  // box2d需要设置两次轮廓才能正确显示
  const iframeWindow = getIframe()
  previewSingleBox2dShape(node)
  iframeWindow.box2d.debugDraw = false
  iframeWindow.box2d.debugDraw = true
  iframeWindow.box2d.debugFlags = 17
  previewSingleBox2dShape(node)
}
export const closePreviewSingleBox2dShape = (node: qc.Node) => {
  psRemoveBox2dBody(node)
}
export const refreshPreviewBox2dShape = (activeNode: qc.Node) => {
  // 先关闭所有刚体轮廓,然后再打开当前的节点刚体轮廓
  const gamePlay = getGamePlay()
  const nodes = getDescendants(gamePlay)
  for (const i in nodes) {
    const node: qc.Node | undefined = nodes[i]
    if (node && isRigidBody(node) && !isFreeDrawLineNode(node)) {
      closePreviewSingleBox2dShape(node)
    }
  }
  previewSingleBox2dShapeDoubleHack(activeNode)
}

export const getUpdateBox2dAction = (value: box2dActionValue) => {
  return {
    value,
    execute: ({ node, newValue }: box2dActionValue) => {
      updateBox2d(node, newValue)
      EventBus.$emit(Event.BOX2D_UPDATE)
    },
    undo: ({ node, oldValue }: box2dActionValue) => {
      updateBox2d(node, oldValue)
      EventBus.$emit(Event.BOX2D_UPDATE)
    },
    methodName: 'getUpdateBox2dAction',
  }
}
